import { gql } from "@apollo/client";
import { useLazyQuery } from "@apollo/client/react";
import { useEffect, useState } from "react";
import styled from "styled-components";

import Parameter from "./Parameter";
import Parameters from "./Parameters.graphql";
import { taxonomy } from "../../api";
import { FluidAccent } from "../../ui-kit";

export const Component = styled(Parameter)`
    ${ FluidAccent }
`;

export function getID(entity) {
    return entity.id;
}

export const name = "Parameter";

export function useSearch(token: string) {
    const [execute, { called, data, error, loading }] = useLazyQuery(
        gql(Parameters),
        {
            client: taxonomy,
        },
    );

    useEffect(
        () => {
            if (token.length < 3) return;

            if (!called) {
                void execute();
            }
        },
        [called, token],
    );

    const [results, setResults] = useState(undefined);

    useEffect(
        () => {
            if (token.length > 2 && data) {
                setResults(
                    data.parameters.filter(
                        (parameter) => parameter.id.includes(token) || parameter.name.some(
                            (name) => name.text.toLowerCase().includes(token.toLowerCase())
                        )
                    )
                );
            } else {
                setResults([]);
            }
        },
        [data, token],
    );

    return {
        error,
        loading,
        results,
    };
}
